module.exports = __webpack_public_path__ + "images/rich_heading/hobby_fashion/secondhand_book/icon_7a7b8d2870efbae59e00fe861c4c8bcb.png";